import { useEffect, useRef } from 'react';
import { useUiStore } from '@/stores/ui';
import { usePasteToTask } from '@/hooks/usePasteToTask';

export const GlobalPasteHandler = () => {
    const pasteTrigger = useUiStore((state) => state.pasteTrigger);
    const { handlePasteToTask } = usePasteToTask();
    const handlerRef = useRef(handlePasteToTask);

    useEffect(() => {
        handlerRef.current = handlePasteToTask;
    }, [handlePasteToTask]);

    useEffect(() => {
        if (pasteTrigger > 0) {
            handlerRef.current();
        }
    }, [pasteTrigger]);

    return null; // This is a side-effect component, no UI
};